import $ from 'jquery';

export const show_tooltip = () => {
	const $tooltip = $( '.tooltip' );

	$tooltip.on( 'mouseenter', (e) => {
		e.preventDefault();

		const $parent = $(e.currentTarget).closest( '.tooltip__parent' );
		const $wrapper = $($parent.find( '.tooltip__wrapper' ));

		$wrapper.addClass( 'tooltip__wrapper--active' );
	} );

	$tooltip.on( 'mouseleave', (e) => {
		e.preventDefault();

		const $parent = $(e.currentTarget).closest( '.tooltip__parent' );
		const $wrapper = $($parent.find( '.tooltip__wrapper' ));

		$wrapper.removeClass( 'tooltip__wrapper--active' );
	} );

	$tooltip.on( 'click', (e) => {
		if ( $(e.currentTarget).data('url') ) {
			window.open($(e.currentTarget).data('url'), '_blank')
		}

		//link on mobile only
		if ( $(window).width() < 640 && $(e.currentTarget).data('mobile_url') ) {
			window.open($(e.currentTarget).data('url'), '_blank')
		}
	} )
};

show_tooltip();